/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartMedicineDetailAliases {
  CONTEXTUAL_BAR_MEDICINE_DETAIL = 'contextual-bar-medicine-detail',
  DATE_FIELD_0 = 'date-field-0',
  FIELD_ADMINISTRATE_ROUTE = 'field-administrate-route',
  FIELD_DOSE = 'field-dose',
  FIELD_INTERVAL = 'field-interval',
  FIELD_MEDICINE = 'field-medicine',
  FIELD_START_DATE = 'field-start-date',
  FIELD_UNIT_MEASUREMENT = 'field-unit-measurement',
  FORM_MEDICINES = 'form-medicines',
  INPUT_0 = 'input-0',
  INPUT_1 = 'input-1',
  INPUT_2 = 'input-2',
  INPUT_3 = 'input-3',
  INPUT_4 = 'input-4',
  LAYOUT_MEDICINE_DETAIL = 'layout-medicine-detail',
  PANEL_MEDICINES = 'panel-medicines',
}
export { MyChartMedicineDetailAliases };
